<div class="dt-main">
  <app-sidebar></app-sidebar>
  <div class="dt-content-wrapper">
    <div class="dt-content">
      <div class="col-md-9 spc-padding d-flex flex-column">
        <div class="form-check form-switch ps-0">
          <div style="width: 80%">
            <h2 class="pageHeading">
              <span class="main-chevron">
                <svg
                  width="10"
                  height="15"
                  viewBox="0 0 10 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.666748 7.5L7.91675 14.75L9.6205 13.0463L4.08633 7.5L9.6205 1.95375L7.91675 0.250003L0.666748 7.5Z"
                    fill="#0D1758"
                  ></path>
                </svg>
              </span>
              Live Usage
            </h2>
          </div>
          <div>
            <label for="toggle">Combine Phases</label>
            <input
              class="form-check-input"
              type="checkbox"
              [ngStyle]="{
                'background-color': combinePhases ? '#1fab3d' : '#E04A41'
              }"
              role="switch"
              id="flexSwitchCheckChecked"
              [checked]="combinePhases"
              (click)="toggleCombinedPhases($event)"
            />
          </div>
        </div>

        <div
          class="card bggrey tabs-container live-usage-table-list-cont flex-grow-1"
        >
          <div>
            <div
              (click)="createMeterModal()"
              style="cursor: pointer; float: left"
              *ngIf="this.isInstalledUser"
            >
              <svg
                width="136"
                height="31"
                viewBox="0 0 136 31"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="135"
                  height="30"
                  rx="5.5"
                  stroke="#0D1758"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.0003 12.167C20.3685 12.167 20.667 12.4655 20.667 12.8337V14.8337H22.667C23.0352 14.8337 23.3337 15.1321 23.3337 15.5003C23.3337 15.8685 23.0352 16.167 22.667 16.167H20.667V18.167C20.667 18.5352 20.3685 18.8337 20.0003 18.8337C19.6321 18.8337 19.3337 18.5352 19.3337 18.167V16.167H17.3337C16.9655 16.167 16.667 15.8685 16.667 15.5003C16.667 15.1321 16.9655 14.8337 17.3337 14.8337H19.3337V12.8337C19.3337 12.4655 19.6321 12.167 20.0003 12.167Z"
                  fill="#0D1758"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.667 15.5003C12.667 11.4502 15.9502 8.16699 20.0003 8.16699C24.0504 8.16699 27.3337 11.4502 27.3337 15.5003C27.3337 19.5504 24.0504 22.8337 20.0003 22.8337C15.9502 22.8337 12.667 19.5504 12.667 15.5003ZM20.0003 9.50033C16.6866 9.50033 14.0003 12.1866 14.0003 15.5003C14.0003 18.814 16.6866 21.5003 20.0003 21.5003C23.314 21.5003 26.0003 18.814 26.0003 15.5003C26.0003 12.1866 23.314 9.50033 20.0003 9.50033Z"
                  fill="#0D1758"
                />
                <path
                  d="M36.345 21L40.32 10.35H42.09L46.08 21H44.19L43.38 18.705H39.03L38.235 21H36.345ZM39.585 17.145H42.84L41.22 12.525H41.19L39.585 17.145ZM50.6297 21.12C49.5997 21.12 48.7497 20.775 48.0797 20.085C47.4097 19.395 47.0747 18.49 47.0747 17.37C47.0747 16.27 47.4097 15.365 48.0797 14.655C48.7597 13.935 49.6047 13.575 50.6147 13.575C51.6147 13.575 52.3947 13.91 52.9547 14.58H52.9697V9.96H54.6347V21H53.0297V20.01H53.0147C52.4447 20.75 51.6497 21.12 50.6297 21.12ZM49.3697 18.975C49.7697 19.385 50.2747 19.59 50.8847 19.59C51.4947 19.59 52.0047 19.385 52.4147 18.975C52.8247 18.565 53.0297 18.035 53.0297 17.385C53.0297 16.725 52.8297 16.18 52.4297 15.75C52.0297 15.31 51.5197 15.09 50.8997 15.09C50.2997 15.09 49.7947 15.3 49.3847 15.72C48.9847 16.14 48.7847 16.695 48.7847 17.385C48.7847 18.035 48.9797 18.565 49.3697 18.975ZM59.9314 21.12C58.9014 21.12 58.0514 20.775 57.3814 20.085C56.7114 19.395 56.3764 18.49 56.3764 17.37C56.3764 16.27 56.7114 15.365 57.3814 14.655C58.0614 13.935 58.9064 13.575 59.9164 13.575C60.9164 13.575 61.6964 13.91 62.2564 14.58H62.2714V9.96H63.9364V21H62.3314V20.01H62.3164C61.7464 20.75 60.9514 21.12 59.9314 21.12ZM58.6714 18.975C59.0714 19.385 59.5764 19.59 60.1864 19.59C60.7964 19.59 61.3064 19.385 61.7164 18.975C62.1264 18.565 62.3314 18.035 62.3314 17.385C62.3314 16.725 62.1314 16.18 61.7314 15.75C61.3314 15.31 60.8214 15.09 60.2014 15.09C59.6014 15.09 59.0964 15.3 58.6864 15.72C58.2864 16.14 58.0864 16.695 58.0864 17.385C58.0864 18.035 58.2814 18.565 58.6714 18.975ZM73.2319 21.12C72.2019 21.12 71.3519 20.775 70.6819 20.085C70.0219 19.395 69.6919 18.49 69.6919 17.37C69.6919 16.27 70.0269 15.365 70.6969 14.655C71.3669 13.935 72.2069 13.575 73.2169 13.575C74.1969 13.575 74.9519 13.91 75.4819 14.58L75.5119 14.565V13.68H77.1919V21H75.5869V20.04L75.5569 20.025C75.0169 20.755 74.2419 21.12 73.2319 21.12ZM73.5019 19.59C74.0819 19.59 74.5719 19.385 74.9719 18.975C75.3819 18.565 75.5869 18.035 75.5869 17.385C75.5869 16.735 75.3869 16.19 74.9869 15.75C74.5969 15.31 74.1019 15.09 73.5019 15.09C72.9019 15.09 72.4019 15.3 72.0019 15.72C71.6019 16.14 71.4019 16.695 71.4019 17.385C71.4019 18.035 71.5969 18.565 71.9869 18.975C72.3769 19.385 72.8819 19.59 73.5019 19.59ZM83.5505 21V10.35H85.3655L88.8755 16.725H88.9055L92.4155 10.35H94.2305V21H92.4155V13.875H92.3855L89.4755 18.945H88.2905L85.3805 13.875H85.3655V21H83.5505ZM103.316 17.25C103.316 17.44 103.301 17.655 103.271 17.895H97.9313C98.0413 18.425 98.2813 18.84 98.6513 19.14C99.0313 19.44 99.5063 19.59 100.076 19.59C100.846 19.59 101.461 19.305 101.921 18.735L103.091 19.74C102.381 20.66 101.346 21.12 99.9863 21.12C98.8663 21.12 97.9513 20.775 97.2413 20.085C96.5413 19.395 96.1913 18.48 96.1913 17.34C96.1913 16.22 96.5313 15.315 97.2113 14.625C97.9013 13.925 98.7863 13.575 99.8663 13.575C100.886 13.575 101.716 13.92 102.356 14.61C102.996 15.3 103.316 16.18 103.316 17.25ZM101.006 15.495C100.706 15.225 100.321 15.09 99.8513 15.09C99.3813 15.09 98.9763 15.22 98.6363 15.48C98.3063 15.74 98.0813 16.105 97.9613 16.575H101.621C101.511 16.115 101.306 15.755 101.006 15.495ZM107.224 21.12C106.584 21.12 106.084 20.915 105.724 20.505C105.364 20.095 105.184 19.49 105.184 18.69V15.105H104.284V13.68H105.184V11.25L106.864 11.07V13.68H109.009V15.105H106.864V18.525C106.864 18.895 106.919 19.16 107.029 19.32C107.139 19.47 107.319 19.545 107.569 19.545C107.899 19.545 108.259 19.44 108.649 19.23L109.084 20.685C108.554 20.975 107.934 21.12 107.224 21.12ZM116.866 17.25C116.866 17.44 116.851 17.655 116.821 17.895H111.481C111.591 18.425 111.831 18.84 112.201 19.14C112.581 19.44 113.056 19.59 113.626 19.59C114.396 19.59 115.011 19.305 115.471 18.735L116.641 19.74C115.931 20.66 114.896 21.12 113.536 21.12C112.416 21.12 111.501 20.775 110.791 20.085C110.091 19.395 109.741 18.48 109.741 17.34C109.741 16.22 110.081 15.315 110.761 14.625C111.451 13.925 112.336 13.575 113.416 13.575C114.436 13.575 115.266 13.92 115.906 14.61C116.546 15.3 116.866 16.18 116.866 17.25ZM114.556 15.495C114.256 15.225 113.871 15.09 113.401 15.09C112.931 15.09 112.526 15.22 112.186 15.48C111.856 15.74 111.631 16.105 111.511 16.575H115.171C115.061 16.115 114.856 15.755 114.556 15.495ZM118.599 21V13.68H120.279V14.775H120.309C120.909 13.975 121.664 13.575 122.574 13.575H122.784V15.45C122.524 15.43 122.354 15.42 122.274 15.42C121.654 15.42 121.164 15.62 120.804 16.02C120.454 16.41 120.279 16.915 120.279 17.535V21H118.599Z"
                  fill="#0D1758"
                />
              </svg>
            </div>

            <ul
              ngbNav
              #nav="ngbNav"
              [(activeId)]="active"
              class="nav-tabs"
            >
              <!-- <li [ngbNavItem]="1">
                <a ngbNavLink>Assets</a>
                <ng-template ngbNavContent>
                  <div class="customScroll inventory_col">
                    <div class="panelHeading headerClass">
                      <div class="panelRunning">Running</div>
                      <div class="panelPercentage flex-grow-4">Percentage</div>
                      <div class="panelHeaderCurrent">
                        <label>
                          <input
                            id="radioPanelCurrent"
                            type="radio"
                            name="current"
                            (click)="radioMainEdit($event)"
                            [checked]="currentSelection"
                          />
                          Amps
                        </label>
                      </div>
                      <div class="panelHeaderEnergy">
                        <label>
                          <input
                            id="radioPanelEnergy"
                            type="radio"
                            name="energy"
                            (click)="radioMainEdit($event)"
                            [checked]="energySelection"
                          />
                          Energy
                        </label>
                      </div>
                      <!~~ <div class="panelHeaderCost">
                        <label>
                          <input
                            id="radioPanelCost"
                            type="radio"
                            name="cost"
                            (click)="radioMainEdit($event)"
                            [checked]="costSelection"
                          />
                          Cost
                        </label>
                      </div> ~~>
                    </div>

                    <div
                      *ngFor="
                        let circuitCategory of circuitCategoryMain;
                        let i = index
                      "
                    >
                      <div class="panelRow panelHeading live-usage-row">
                        <div class="live-usage-row-heading">
                          <div class="colorbx">
                            <span
                              class="design"
                              [ngStyle]="{ background: circuitCategory.colour }"
                            ></span>
                          </div>

                          <div
                            class="heading"
                            [ngStyle]="{
                              color: circuitCategory.totalCurrent
                                ? '#1fab3d'
                                : 'grey',
                              'word-break': 'break-word'
                            }"
                          >
                            {{ circuitCategory.name }}
                          </div>
                        </div>

                        <div class="icon-container">
                          <div
                            class="traingle"
                            id="arrow"
                            [attr.aria-expanded]="isInventryCollapsed[i]"
                            (click)="collapse.toggle()"
                            aria-controls="collapseExample"
                          ></div>

                          <a
                            href="javascript: void(0);"
                            aria-disabled="false"
                            [attr.id]="circuitCategory.name"
                            (click)="openCircuitCategoryModal(circuitCategory)"
                          >
                            <svg
                              fill="#B0BFE5"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="18px"
                              height="18px"
                            >
                              <path
                                d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z"
                              ></path>
                            </svg>
                          </a>
                        </div>

                        <ng-container
                          *ngIf="circuitCategory.circuitIsconnected"
                        >
                          <div
                            [ngClass]="'panelPercentage'"
                            class="percentageContainer"
                          >
                            <!~~ TODO: Need to calculate width based on %  ~~>
                            <div
                              [ngClass]="'percentagebx'"
                              [ngStyle]="{
                                'width.px': circuitCategory.totalCurrent
                                  ? customToFixed(
                                      (100 * circuitCategory.totalCurrent) /
                                        totalAssetCurrent,
                                      3,
                                      true
                                    )
                                  : 1,
                                background: circuitCategory.totalCurrent
                                  ? '#1fab3d'
                                  : 'grey',
                                'height.px': 10
                              }"
                            ></div>

                            <p
                              class="percetangeTextcustom"
                              [ngStyle]="{
                                color: circuitCategory.totalCurrent
                                  ? '#1fab3d'
                                  : 'grey'
                              }"
                            >
                              {{
                                circuitCategory.totalCurrent
                                  ? customToFixed(
                                      (100 * circuitCategory.totalCurrent) /
                                        totalAssetCurrent,
                                      3,
                                      true
                                    ) + '%'
                                  : '0%'
                              }}
                            </p>
                          </div>

                          <div
                            *ngIf="currentSelection"
                            id="panel_current"
                            class="panelCurrent energyTextcustom"
                            [ngStyle]="{
                              color: circuitCategory.totalCurrent
                                ? '#1fab3d'
                                : 'grey'
                            }"
                          >
                            <p>
                              {{
                                circuitCategory.totalCurrent != null
                                  ? customToFixed(
                                      circuitCategory.totalCurrent,
                                      3
                                    ) + 'a'
                                  : ''
                              }}
                            </p>
                          </div>

                          <div
                            *ngIf="energySelection"
                            class="panelCurrent energyTextcustom"
                            [ngStyle]="{
                              color: circuitCategory.totalPower
                                ? '#1fab3d'
                                : 'grey'
                            }"
                          >
                            <p>
                              {{
                                circuitCategory.totalPower != null
                                  ? customToFixed(
                                      circuitCategory.totalPower,
                                      1
                                    ) + 'w'
                                  : '
                            '
                              }}
                            </p>
                          </div>

                          <div
                            *ngIf="costSelection"
                            class="panelCurrent energyTextcustom"
                            [ngStyle]="{
                              color: circuitCategory.totalCost
                                ? '#1fab3d'
                                : 'grey'
                            }"
                          >
                            <p>
                              {{
                                circuitCategory.totalCost != null
                                  ? '$' + circuitCategory.totalCost
                                  : ' '
                              }}
                            </p>
                          </div>
                        </ng-container>
                      </div>

                      <div
                        #collapse="ngbCollapse"
                        [(ngbCollapse)]="isInventryCollapsed[i]"
                      >
                        <div
                          class="panelList panelList-cutom live-usage-row"
                          *ngFor="
                            let subCategory of combinePhases
                              ? circuitCategory.circuit_setGroup
                              : circuitCategory.circuit_set
                          "
                        >
                          <div
                            class="panelName live-usage-row-heading"
                            [ngStyle]="{
                              color:
                                subCategory.circuit_current > 0
                                  ? '#1fab3d'
                                  : 'grey',
                              'word-break': 'break-word'
                            }"
                          >
                            <span
                              class="circle"
                              [ngStyle]="{ background: circuitCategory.colour }"
                            ></span>
                            {{
                              combinePhases
                                ? subCategory.circuit_group_temp
                                : subCategory.circuit_name
                            }}
                          </div>

                          <div class="icon-container">
                            <div></div>

                            <a
                              href="javascript: void(0);"
                              aria-disabled="false"
                              [attr.id]="
                                combinePhases
                                  ? subCategory.circuit_group_temp
                                  : subCategory.circuit_name
                              "
                              (click)="handleOpenCircuitModel(subCategory)"
                            >
                              <svg
                                fill="#B0BFE5"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="18px"
                                height="18px"
                              >
                                <path
                                  d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z"
                                ></path>
                              </svg>
                            </a>

                            <div></div>
                          </div>

                          <div
                            class="panelPercentage"
                            class="percentageContainer"
                          >
                            <ng-container *ngIf="subCategory.connected">
                              <div
                                class="percentagebx"
                                [ngStyle]="{
                                  'width.px': subCategory.circuit_current
                                    ? customToFixed(
                                        (100 * subCategory.circuit_current) /
                                          circuitCategory.totalCurrent,
                                        3,
                                        true
                                      )
                                    : 1,
                                  background: subCategory.circuit_current
                                    ? '#1fab3d'
                                    : 'grey',
                                  'height.px': 10,
                                  'border-radius.px': 3
                                }"
                              ></div>

                              <div
                                class="percentagebx-box-cont-num"
                                [ngStyle]="{
                                  color:
                                    subCategory.circuit_current > 0
                                      ? '#1fab3d'
                                      : 'grey'
                                }"
                              >
                                <p>
                                  {{
                                    subCategory.circuit_current
                                      ? customToFixed(
                                          (100 * subCategory.circuit_current) /
                                            circuitCategory.totalCurrent,
                                          3,
                                          true
                                        ) + '%'
                                      : '0%'
                                  }}
                                </p>
                              </div>
                            </ng-container>

                            <!~~ This renders Disconnected ~~>
                            <div
                              class="percentagebx-box-cont-num-disconnect"
                              *ngIf="!subCategory.connected"
                            >
                              <p>Not Set-Up</p>
                            </div>
                          </div>

                          <div
                            *ngIf="currentSelection"
                            class="panelCurrent currentTextcustomPanel"
                            [ngStyle]="{
                              color:
                                subCategory.circuit_current > 0
                                  ? '#1fab3d'
                                  : 'grey'
                            }"
                          >
                            <p>
                              {{
                                subCategory.circuit_current != null
                                  ? customToFixed(
                                      subCategory.circuit_current,
                                      3
                                    ) + 'a'
                                  : ''
                              }}
                            </p>
                          </div>

                          <div
                            *ngIf="energySelection"
                            class="panelCurrent currentTextcustomPanel"
                            [ngStyle]="{
                              color:
                                subCategory.circuit_power > 0
                                  ? '#1fab3d'
                                  : 'grey'
                            }"
                          >
                            <p>
                              {{
                                subCategory.circuit_power != null
                                  ? customToFixed(
                                      subCategory.circuit_power,
                                      1
                                    ) + 'w'
                                  : ''
                              }}
                            </p>
                          </div>

                          <div
                            *ngIf="costSelection"
                            class="panelCurrent currentTextcustomPanel"
                            [ngStyle]="{
                              color:
                                subCategory.circuit_cost > 0
                                  ? '#1fab3d'
                                  : 'grey'
                            }"
                          >
                            <p>
                              {{
                                subCategory.circuit_cost != null
                                  ? '$' + subCategory.circuit_cost
                                  : ''
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </li> -->

              <li [ngbNavItem]="2">
                <a ngbNavLink>Panels</a>

                <ng-template ngbNavContent>
                  <div class="customScroll">
                    <div class="panelHeading headerClass">
                      <div class="panelRunning">Running</div>
                      <div class="panelPercentage flex-grow-4">Percentage</div>
                      <div class="panelHeaderCurrent">
                        <label>
                          <input
                            id="radioPanelCurrent"
                            type="radio"
                            name="current"
                            (click)="radioMainEdit($event)"
                            [checked]="currentSelection"
                          />
                          Amps
                        </label>
                      </div>

                      <div class="panelHeaderEnergy">
                        <label>
                          <input
                            id="radioPanelEnergy"
                            type="radio"
                            name="energy"
                            (click)="radioMainEdit($event)"
                            [checked]="energySelection"
                          />
                          Energy
                        </label>
                      </div>
                      <!-- <div class="panelHeaderCost">
                        <label>
                          <input
                            id="radioPanelCost"
                            type="radio"
                            name="cost"
                            (click)="radioMainEdit($event)"
                            [checked]="costSelection"
                          />
                          Cost
                        </label>
                      </div> -->
                    </div>

                    <ng-container *ngFor="let panel of panels; let i = index">
                      <div *ngIf="!secondaryPanelSet.has(panel.panel_id)">
                        <div class="panelRow panelHeading live-usage-row">
                          <div class="live-usage-row-heading">
                            <!-- TODO: Add changes to handle deactivated panels when status added to db -->
                            <div class="greybx">
                              <span
                                [ngClass]="
                                  panel.panelIsconnected ? 'green' : 'red'
                                "
                              ></span>
                            </div>

                            <div
                              class="heading"
                              [ngStyle]="{
                                color: panel.panelIsconnected
                                  ? '#1fab3d'
                                  : 'grey',
                                'word-break': 'break-word'
                              }"
                            >
                              {{ panel.panel_name }}
                            </div>
                          </div>

                          <div class="icon-container">
                            <div
                              class="traingle"
                              id="arrow"
                              [attr.aria-expanded]="isPanelCollapsed[i]"
                              (click)="collapse.toggle()"
                              aria-controls="collapseExample"
                            ></div>

                            <a
                              href="javascript: void(0);"
                              aria-disabled="false"
                              [attr.id]="panel.panel_name"
                              (click)="openInfoModal(panel)"
                            >
                              <svg
                                fill="#ccc"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="18px"
                                height="18px"
                              >
                                <path
                                  d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z"
                                ></path>
                              </svg>
                            </a>

                            <a
                              href="javascript: void(0);"
                              aria-disabled="false"
                              [attr.id]="panel.panel_name"
                              (click)="openReportModal(panel)"
                              *ngIf="
                                isInstalledUser && panel.meter_type != null
                              "
                            >
                              <img
                                src="assets/images/Vector.png"
                                alt="arrow"
                              />
                            </a>

                            <div
                              *ngIf="
                                !isInstalledUser || panel.meter_type === null
                              "
                            ></div>
                          </div>

                          <!-- TODO: change based on connected status  -->
                          <ng-container *ngIf="panel.panelIsconnected">
                            <div
                              [ngClass]="'panelPercentage'"
                              class="percentageContainer"
                              *ngIf="currentSelection"
                            >
                              <!-- TODO: Need to calculate width based on %  -->
                              <div
                                [ngClass]="'percentagebx'"
                                [ngStyle]="{
                                  'width.px': customToFixed(
                                    panel.panelCurrentPercentage
                                  ),
                                  background: panel.panelCurrentPercentage
                                    ? '#1fab3d'
                                    : 'grey',
                                  'height.px': 10
                                }"
                              ></div>
                              <p class="percetangeTextcustom">
                                {{
                                  panel.panelCurrentPercentage
                                    ? customToFixed(
                                        panel.panelCurrentPercentage,
                                        3,
                                        true
                                      )
                                    : '0'
                                }}%
                              </p>
                            </div>
                            <div
                              [ngClass]="'panelPercentage'"
                              class="percentageContainer"
                              *ngIf="energySelection"
                            >
                              <!-- TODO: Need to calculate width based on %  -->
                              <div
                                [ngClass]="'percentagebx'"
                                [ngStyle]="{
                                  'width.px': customToFixed(
                                    panel.panelPowerPercentage
                                  ),
                                  background: panel.panelPowerPercentage
                                    ? '#1fab3d'
                                    : 'grey',
                                  'height.px': 10
                                }"
                              ></div>
                              <p class="percetangeTextcustom">
                                {{
                                  panel.panelPowerPercentage
                                    ? customToFixed(
                                        panel.panelPowerPercentage,
                                        3,
                                        true
                                      )
                                    : '0'
                                }}%
                              </p>
                            </div>

                            <div
                              *ngIf="currentSelection"
                              id="panel_current"
                              class="panelCurrent currentTextcustomPanel"
                              [ngStyle]="{
                                color: panel.panel_current ? '#1fab3d' : 'grey'
                              }"
                            >
                              <p>
                                {{
                                  isValuePresent(panel.panel_current)
                                    ? customToFixed(panel.panel_current, 3) +
                                      'a'
                                    : ''
                                }}
                              </p>
                            </div>

                            <div
                              *ngIf="energySelection"
                              class="panelCurrent currentTextcustomPanel"
                              [ngStyle]="{
                                color: panel.panel_power ? '#1fab3d' : 'grey'
                              }"
                            >
                              <p>
                                {{
                                  isValuePresent(panel.panel_power)
                                    ? customToFixed(panel.panel_power, 1) + 'w'
                                    : ' '
                                }}
                              </p>
                            </div>

                            <div
                              *ngIf="costSelection"
                              class="panelCurrent currentTextcustomPanel"
                              style="display: flex; align-items: center"
                              [ngStyle]="{
                                color: panel.panel_cost ? '#1fab3d' : 'grey'
                              }"
                            >
                              <p>${{ panel.panel_cost ?? '0' }}</p>
                            </div>
                          </ng-container>

                          <div
                            *ngIf="!panel.panelIsconnected"
                            class="panelIsconnectedSec"
                          >
                            <div
                              [ngClass]="
                                'panelPercentage disc custompanelIsconnectedCont'
                              "
                            >
                              <!-- TODO: Need to calculate width based on %  -->
                              <div>
                                {{
                                  panel.panelIsconnected
                                    ? ''
                                    : panel.meter_name
                                    ? 'Disconnected'
                                    : 'Not Set-Up'
                                }}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          #collapse="ngbCollapse"
                          [(ngbCollapse)]="isPanelCollapsed[i]"
                        >
                          <div
                            class="panelList panelList-cutom live-usage-row"
                            *ngFor="
                              let circuit of combinePhases
                                ? panel.panel_circuitsGrouped
                                : panel.panel_circuits
                            "
                          >
                            <div
                              class="panelName live-usage-row-heading"
                              [ngStyle]="{
                                color: circuit.circuit_current
                                  ? '#1fab3d'
                                  : 'grey',
                                'word-break': 'break-word'
                              }"
                            >
                              <span
                                class="circle"
                                [ngStyle]="{
                                  background: circuit.category_color
                                }"
                              ></span>
                              {{
                                combinePhases
                                  ? circuit.circuit_group_temp
                                  : circuit.circuit_name
                              }}
                            </div>

                            <div class="icon-container">
                              <div></div>

                              <a
                                href="javascript: void(0);"
                                aria-disabled="false"
                                [attr.id]="
                                  combinePhases
                                    ? circuit.circuit_group_temp
                                    : circuit.circuit_name
                                "
                                (click)="openCircuitModal(circuit)"
                              >
                                <svg
                                  fill="#B0BFE5"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width="18px"
                                  height="18px"
                                >
                                  <path
                                    d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z"
                                  ></path>
                                </svg>
                              </a>

                              <div></div>
                            </div>

                            <div
                              class="panelPercentage"
                              class="percentageContainer"
                            >
                              <!-- This renders Bar -->

                              <ng-container
                                *ngIf="
                                  circuit.connected ||
                                  circuit.panel_meter_channels.length > 0
                                "
                              >
                                <div
                                  class="percentagebx"
                                  [ngStyle]="{
                                    'width.px':
                                      panel.panel_current &&
                                      (circuit.circuit_current ?? 0)
                                        ? customToFixed(
                                            (100 *
                                              (circuit.circuit_current ?? 0)) /
                                              panel.panel_current,
                                            3,
                                            true
                                          )
                                        : 1,
                                    background:
                                      panel.panel_current &&
                                      (circuit.circuit_current ?? 0)
                                        ? '#1fab3d'
                                        : 'grey',
                                    'height.px': 10,
                                    'border-radius.px': 3
                                  }"
                                ></div>

                                <div
                                  class="percentagebx-box-cont-num"
                                  [ngStyle]="{
                                    color:
                                      circuit.circuit_current ?? 0
                                        ? '#1fab3d'
                                        : 'grey'
                                  }"
                                >
                                  <p>
                                    {{
                                      panel.panel_current
                                        ? customToFixed(
                                            (100 *
                                              (circuit.circuit_current ?? 0)) /
                                              panel.panel_current,
                                            3,
                                            true
                                          ) + '%'
                                        : '-'
                                    }}
                                  </p>
                                </div>
                              </ng-container>

                              <div
                                *ngIf="
                                  !circuit.connected &&
                                  !circuit.panel_meter_channels.length
                                "
                                class="percentagebx-box-cont-num-disconnect"
                              >
                                <p>Not Set-Up</p>
                              </div>
                            </div>

                            <div
                              *ngIf="currentSelection"
                              class="panelCurrent currentTextcustomPanel"
                              [ngStyle]="{
                                color:
                                  circuit.circuit_current > 0
                                    ? '#1fab3d'
                                    : 'grey'
                              }"
                            >
                              <p>
                                {{
                                  isValuePresent(circuit.circuit_current)
                                    ? customToFixed(
                                        circuit.circuit_current,
                                        3
                                      ) + 'a'
                                    : ''
                                }}
                              </p>
                            </div>

                            <div
                              *ngIf="energySelection"
                              class="panelCurrent currentTextcustomPanel"
                              [ngStyle]="{
                                color: circuit.circuit_power
                                  ? '#1fab3d'
                                  : 'grey'
                              }"
                            >
                              <p>
                                {{
                                  isValuePresent(circuit.circuit_power)
                                    ? customToFixed(circuit.circuit_power, 1) +
                                      'w'
                                    : ''
                                }}
                              </p>
                            </div>

                            <div
                              *ngIf="costSelection"
                              class="panelCurrent currentTextcustomPanel"
                              [ngStyle]="{
                                color: circuit.circuit_cost ? '#1fab3d' : 'grey'
                              }"
                            >
                              <p>
                                {{
                                  isValuePresent(circuit.circuit_cost)
                                    ? '$' + circuit.circuit_cost
                                    : ''
                                }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </ng-template>
              </li>

              <li [ngbNavItem]="3">
                <a ngbNavLink>Circuits</a>

                <ng-template ngbNavContent>
                  <div class="customScroll">
                    <div class="panelHeading headerClass">
                      <div class="panelRunning">Running</div>
                      <div class="panelPercentage flex-grow-4">Percentage</div>
                      <div class="panelHeaderCurrent">
                        <label>
                          <input
                            id="radioPanelCurrent"
                            type="radio"
                            name="current"
                            (click)="radioMainEdit($event)"
                            [checked]="currentSelection"
                          />
                          Amps
                        </label>
                      </div>

                      <div class="panelHeaderEnergy">
                        <label>
                          <input
                            id="radioPanelEnergy"
                            type="radio"
                            name="energy"
                            (click)="radioMainEdit($event)"
                            [checked]="energySelection"
                          />
                          Energy
                        </label>
                      </div>

                      <!-- <div class="panelHeaderCost">
                        <label>
                          <input
                            id="radioPanelCost"
                            type="radio"
                            name="cost"
                            (click)="radioMainEdit($event)"
                            [checked]="costSelection"
                          />
                          Cost
                        </label>
                      </div> -->
                    </div>

                    <!-- <div
                      *ngFor="
                        let circuitCategory of circuitCategoryMain;
                        let i = index
                      "
                    > -->
                    <div
                      class="panelList panelList-cutom panelRow live-usage-row"
                      *ngFor="let subCategory of circuits; let i = index"
                    >
                      <div
                        class="panelName live-usage-row-heading"
                        [ngStyle]="{
                          color:
                            subCategory.circuit_current > 0
                              ? '#1fab3d'
                              : 'grey',
                          'word-break': 'break-word'
                        }"
                      >
                        <span
                          class="circle"
                          [ngStyle]="{ background: subCategory.color }"
                        ></span>
                        {{
                          combinePhases
                            ? subCategory.circuit_group_temp
                            : subCategory.circuit_name
                        }}
                      </div>

                      <div class="icon-container">
                        <div></div>

                        <a
                          href="javascript: void(0);"
                          aria-disabled="false"
                          [attr.id]="
                            combinePhases
                              ? subCategory.circuit_group_temp
                              : subCategory.circuit_name
                          "
                          (click)="handleOpenCircuitModel(subCategory)"
                        >
                          <svg
                            fill="#B0BFE5"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="18px"
                            height="18px"
                          >
                            <path
                              d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z"
                            ></path>
                          </svg>
                        </a>

                        <div></div>
                      </div>

                      <div
                        [ngClass]="'panelPercentage'"
                        class="percentageContainer"
                      >
                        <!-- This renders Bar -->
                        <div *ngIf="subCategory.connected">
                          <div class="percentagebx-box-cont">
                            <div
                              [ngClass]="'percentagebx'"
                              [ngStyle]="{
                                'width.px': subCategory.circuit_current
                                  ? customToFixed(
                                      (100 * subCategory.circuit_current) /
                                        totalCurrent,
                                      3,
                                      true
                                    )
                                  : 1,
                                background: subCategory.circuit_current
                                  ? '#1fab3d'
                                  : 'grey',
                                'height.px': 10
                              }"
                            >
                              &nbsp;
                            </div>
                            <div
                              class="percentagebx-box-cont-num"
                              [ngStyle]="{
                                color:
                                  subCategory.circuit_current > 0
                                    ? '#1fab3d'
                                    : 'grey'
                              }"
                            >
                              <p>
                                {{
                                  isValuePresent(subCategory.circuit_current)
                                    ? customToFixed(
                                        (100 * subCategory.circuit_current) /
                                          totalCurrent,
                                        3,
                                        true
                                      ) + '%'
                                    : '0%'
                                }}
                              </p>
                            </div>
                          </div>
                        </div>
                        <!-- This renders Disconnected -->
                        <div *ngIf="!subCategory.connected">
                          <div class="percentagebx-box-cont-num-disconnect">
                            <p>Not Set-Up</p>
                          </div>
                        </div>
                      </div>

                      <div
                        *ngIf="currentSelection"
                        class="panelCurrent currentTextcustomPanel"
                        [ngStyle]="{
                          color:
                            subCategory.circuit_current > 0 ? '#1fab3d' : 'grey'
                        }"
                      >
                        <p>
                          {{
                            isValuePresent(subCategory.circuit_current)
                              ? customToFixed(subCategory.circuit_current, 3) +
                                'a'
                              : ''
                          }}
                        </p>
                      </div>
                      <div
                        *ngIf="energySelection"
                        class="panelCurrent currentTextcustomPanel"
                        [ngStyle]="{
                          color:
                            subCategory.circuit_power > 0 ? '#1fab3d' : 'grey'
                        }"
                      >
                        <p>
                          {{
                            isValuePresent(subCategory.circuit_power)
                              ? customToFixed(subCategory.circuit_power, 1) +
                                'w'
                              : ''
                          }}
                        </p>
                      </div>
                      <div
                        *ngIf="costSelection"
                        class="panelCurrent currentTextcustomPanel"
                        [ngStyle]="{
                          color:
                            subCategory.circuit_cost > 0 ? '#1fab3d' : 'grey'
                        }"
                      >
                        <p>
                          {{
                            isValuePresent(subCategory.circuit_cost)
                              ? '$' + subCategory.circuit_cost
                              : ''
                          }}
                        </p>
                      </div>
                      <!-- </div> -->
                    </div>
                  </div>
                </ng-template>
              </li>
            </ul>
          </div>

          <div
            *ngIf="currentSelection"
            class="panelHeading panelfooter inventory_col live-usage-footer"
          >
            <div class="panelTotal">Total</div>

            <div class="panelpercentagetotal">
              <div class="percentagebx">
                {{
                  active !== 1
                    ? totalCurrent != 0
                      ? '100%'
                      : '0%'
                    : customToFixed(
                        (100 * totalAssetCurrent) / totalCurrent,
                        3,
                        true
                      ) + '%'
                }}
              </div>
            </div>

            <div class="panelEnergywatts">
              {{
                customToFixed(
                  active !== 1 ? totalCurrent : totalAssetCurrent,
                  3
                )
              }}a
            </div>
          </div>

          <div
            *ngIf="energySelection"
            class="panelHeading panelfooter inventory_col live-usage-footer"
          >
            <div class="panelTotal">Total</div>

            <div class="panelpercentagetotal">
              <div class="percentagebx">
                {{
                  active !== 1
                    ? totalPower != 0
                      ? '100%'
                      : '0%'
                    : customToFixed(
                        (100 * totalAssetCurrent) / totalCurrent,
                        3,
                        true
                      ) + '%'
                }}
              </div>
            </div>

            <div class="panelEnergywatts">
              {{
                customToFixed(active !== 1 ? totalPower : totalAssetPower, 1)
              }}w
            </div>
          </div>

          <div
            *ngIf="costSelection"
            class="panelHeading panelfooter inventory_col live-usage-footer"
          >
            <div class="panelTotal">Total</div>

            <div class="panelpercentagetotal">
              <div class="percentagebx">
                {{
                  active !== 1
                    ? totalCost != 0
                      ? '100%'
                      : '0%'
                    : customToFixed(
                        (100 * totalAssetCurrent) / totalCurrent,
                        3,
                        true
                      ) + '%'
                }}
              </div>
            </div>

            <div class="panelEnergywatts">
              ${{ active !== 1 ? totalCost : totalAssetCost }}
            </div>
          </div>
          <div
            [ngbNavOutlet]="nav"
            class="mt-2"
          ></div>
        </div>
        <!-- <div class="graphSection">
          <img src="assets/images/graph.png" alt="graph" class="img-fluid">
        </div> -->
      </div>
      <div class="col-md-3">
        <div class="sidebartab">
          <div class="Bill-Breakdown">
            <div class="arrow-toggle">
              <svg
                width="24"
                height="45"
                viewBox="0 0 24 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 0H12C18.6274 0 24 5.37258 24 12V33C24 39.6274 18.6274 45 12 45H1V0Z"
                  fill="#3649A8"
                />
                <g clip-path="url(#clip0_0_1)">
                  <path
                    d="M16 22L10 16L8.59 17.41L13.17 22L8.59 26.59L10 28L16 22Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_0_1">
                    <rect
                      width="24"
                      height="24"
                      fill="white"
                      transform="translate(24 10) rotate(90)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p class="billbreakdown-side">Load Breakdown</p>
            <div class="bill-breakdown-pie">
              <div
                *ngIf="chartOptions.series && sidebarCategoryActive"
                class="byfees"
              >
                <div class="chartdv">
                  <apx-chart
                    [series]="chartOptions.series"
                    [chart]="chartOptions.chart"
                    [labels]="chartOptions.labels"
                    [responsive]="chartOptions.responsive"
                    [legend]="chartOptions.legend"
                    [dataLabels]="chartOptions.dataLabels"
                    [colors]="chartOptions.colors"
                    [stroke]="chartOptions.stroke"
                  ></apx-chart>
                  <span class="chartper">100%</span>
                </div>
              </div>
              <div
                *ngIf="!chartOptions.series && sidebarCategoryActive"
                class="byfees"
              >
                <div
                  class="chartdv"
                  style="height: '33vh'"
                >
                  <span class="chartper">No Live Data</span>
                </div>
              </div>

              <div
                *ngIf="chartOptionsPanel.series && sidebarPanelActive"
                class="byfees"
              >
                <div class="chartdv">
                  <apx-chart
                    [series]="chartOptionsPanel.series"
                    [chart]="chartOptionsPanel.chart"
                    [labels]="chartOptionsPanel.labels"
                    [responsive]="chartOptionsPanel.responsive"
                    [legend]="chartOptionsPanel.legend"
                    [dataLabels]="chartOptionsPanel.dataLabels"
                    [colors]="chartOptionsPanel.colors"
                    [stroke]="chartOptionsPanel.stroke"
                  ></apx-chart>
                  <span class="chartper">100%</span>
                </div>
              </div>
              <div
                *ngIf="!chartOptionsPanel.series && sidebarPanelActive"
                class="byfees"
              >
                <div
                  class="chartdv"
                  style="height: '33vh'"
                >
                  <span class="chartper">No Live Data</span>
                </div>
              </div>
            </div>
            <div class="flex-grow-1"></div>
            <div class="sidetab">
              <a
                (click)="sidetab('category')"
                [ngClass]="
                  sidebarCategoryActive ? 'sidetablink active' : 'sidetablink'
                "
                >Assets</a
              >
              <a
                (click)="sidetab('panel')"
                [ngClass]="
                  sidebarPanelActive ? 'sidetablink active' : 'sidetablink'
                "
                >Panel</a
              >
            </div>
            <div
              *ngIf="sidebarCategoryActive"
              class="greybx"
            >
              <h4>Assets</h4>
              <div class="cat-opt-box">
                <div
                  *ngFor="
                    let circuitCategory of circuitCategoryMain;
                    let i = index
                  "
                >
                  <div class="greybxWhite">
                    <div class="cat-opt">
                      <input
                        type="checkbox"
                        (change)="checkValue($event)"
                        checked
                        value="{{ circuitCategory.name }}"
                      />
                      <div
                        class="d-flex"
                        style="justify-content: space-between"
                      >
                        <div
                          width="75%"
                          class="inner-cat-opts"
                        >
                          <div class="check blue-text">
                            <svg
                              [ngStyle]="{ fill: circuitCategory.colour }"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24px"
                              height="24px"
                            >
                              <path
                                d="M11,16.4l-4.7-4.7l1.4-1.4l3.3,3.3l8.4-8.4C17.5,3.3,14.9,2,12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10 c0-1.9-0.5-3.6-1.4-5.1L11,16.4z"
                              ></path>
                            </svg>
                          </div>
                          <div
                            class="name"
                            [ngStyle]="{ color: '#0D1758' }"
                          >
                            {{ circuitCategory.name }}
                            <a
                              href="javascript: void(0);"
                              aria-disabled="false"
                              [attr.id]="circuitCategory.name"
                              (click)="
                                openCircuitCategoryModal(circuitCategory)
                              "
                            >
                              <svg
                                [ngStyle]="{ fill: '#ccc' }"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="18px"
                                height="18px"
                              >
                                <path
                                  d="M 12 2  C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z"
                                ></path>
                              </svg>
                            </a>
                          </div>
                        </div>
                        <div
                          width="25%"
                          class="percent"
                          [ngStyle]="{ color: '#0D1758' }"
                        >
                          {{
                            circuitCategory.totalCurrent
                              ? customToFixed(
                                  (100 * circuitCategory.totalCurrent) /
                                    totalAssetCurrent,
                                  1,
                                  true
                                ) + '%'
                              : '0%'
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngIf="sidebarPanelActive"
              class="greybx"
            >
              <h4>Panel</h4>
              <div class="cat-opt-box">
                <ng-container *ngFor="let panel of panels; let i = index">
                  <div *ngIf="!secondaryPanelSet.has(panel.panel_id)">
                    <div class="greybxWhite">
                      <div class="cat-opt">
                        <input
                          type="checkbox"
                          (change)="checkValue($event)"
                          checked
                          value="{{ panel.panel_name }}"
                        />
                        <div
                          class="d-flex"
                          style="justify-content: space-between"
                        >
                          <div
                            width="75%"
                            class="inner-cat-opts"
                          >
                            <div class="check blue-text">
                              <svg
                                [ngStyle]="{
                                  fill: panel.panelIsconnected
                                    ? panel.colour
                                    : 'grey'
                                }"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="24px"
                                height="24px"
                              >
                                <path
                                  d="M11,16.4l-4.7-4.7l1.4-1.4l3.3,3.3l8.4-8.4C17.5,3.3,14.9,2,12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10 c0-1.9-0.5-3.6-1.4-5.1L11,16.4z"
                                ></path>
                              </svg>
                            </div>
                            <div
                              class="name"
                              [ngStyle]="{ color: '#0D1758' }"
                            >
                              {{ panel.panel_name }}
                              <div style="display: inline">
                                <a
                                  href="javascript: void(0);"
                                  aria-disabled="false"
                                  [attr.id]="panel.panel_name"
                                  (click)="openInfoModal(panel)"
                                >
                                  <svg
                                    fill="#ccc"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="18px"
                                    height="18px"
                                  >
                                    <path
                                      d="M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003 6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 7 L 11 9 L 13 9 L 13 7 L 11 7 z M 11 11 L 11 17 L 13 17 L 13 11 L 11 11 z"
                                    ></path>
                                  </svg>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div
                            width="25%"
                            class="percent"
                            [ngStyle]="{ color: '#0D1758' }"
                          >
                            {{
                              panel.panelCurrentPercentage
                                ? customToFixed(
                                    panel.panelCurrentPercentage,
                                    1,
                                    true
                                  )
                                : '0'
                            }}%
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
